export type NamespaceMetricKey =
  | 'k8s.pod.cpu_limit_utilization'
  | 'k8s.pod.cpu_request_utilization'
  | 'k8s.pod.memory_limit_utilization'
  | 'k8s.pod.memory_request_utilization';

// Renamed from uppercase to camelCase to match configuration object standards
export const namespaceMetricKeys: Record<
  'cpuLimit' | 'cpuRequest' | 'memoryLimit' | 'memoryRequest',
  NamespaceMetricKey
> = {
  cpuLimit: 'k8s.pod.cpu_limit_utilization',
  cpuRequest: 'k8s.pod.cpu_request_utilization',
  memoryLimit: 'k8s.pod.memory_limit_utilization',
  memoryRequest: 'k8s.pod.memory_request_utilization',
};

export type JobContainerMetricKey =
  // Driver / Orchestrator Metrics
  | 'driver.k8s.container.memory_request'
  | 'driver.k8s.container.cpu_request'
  | 'driver.container.memory.usage'
  | 'driver.container.cpu.usage'
  // Executor / Worker Metrics
  | 'executor.k8s.container.memory_request'
  | 'executor.k8s.container.cpu_request'
  | 'executor.container.memory.usage'
  | 'executor.container.cpu.usage';

/** Opaque shape for raw performance metrics series data before normalization */
export type RawMetricsSeries = Record<string, unknown> | unknown[];

/** API response format for high-level namespace performance overview queries */
export type NamespaceMetricsResponse = Partial<
  Record<NamespaceMetricKey, RawMetricsSeries>
>;

/** Flat performance map matching the hardware utilization snapshot structure on a single job */
export type JobUtilizationMetrics = Record<JobContainerMetricKey, number | undefined>;

/** Standard error status restrictions handled by telemetry components */
export type TelemetryErrorStatus = 400 | 502 | 503;